(function () {
  window.ogeryCadCurrencySuffixLoaded = true;

  function appendCadToPriceText(text) {
    if (!text || text.indexOf('$') === -1 || text.indexOf('CAD') !== -1) {
      return text;
    }

    return text.replace(/(^|[^\w])(\$\s*[0-9][0-9,]*(?:\.[0-9]{2})?)(?!\s*(?:CAD|USD|AUD|NZD|HKD)\b)/g, function (_, prefix, amount) {
      return prefix + amount.trim() + ' CAD';
    });
  }

  function isCadCurrency() {
    var path = window.location && window.location.pathname ? window.location.pathname.toLowerCase() : '';
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'CAD') ||
      path.indexOf('/en-ca') === 0 ||
      path.indexOf('/fr-ca') === 0;
  }

  function patchCadMoneyFormatter(owner, key) {
    if (!isCadCurrency() || !owner || typeof owner[key] !== 'function' || owner[key]._ogeryCadSuffixPatched) {
      return;
    }

    var originalFormatter = owner[key];
    owner[key] = function () {
      return appendCadToPriceText(originalFormatter.apply(this, arguments));
    };
    owner[key]._ogeryCadSuffixPatched = true;
  }

  function patchCadMoneyFormatters() {
    patchCadMoneyFormatter(window, 'formatMoney');
    if (window.Shopify) {
      patchCadMoneyFormatter(window.Shopify, 'formatMoney');
    }
  }

  function patchPriceElement(element) {
    if (!isCadCurrency() || !element) {
      return;
    }

    Array.prototype.forEach.call(element.childNodes, function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.nodeValue = appendCadToPriceText(node.nodeValue);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        patchPriceElement(node);
      }
    });
  }

  function patchExistingPriceElements(root) {
    if (!isCadCurrency()) {
      return;
    }

    var selectors = [
      'product-bundle-builder .current-price',
      'product-bundle-builder .compare-price',
      'product-bundle-builder .bundle-total-price',
      'product-bundle-builder .bundle-original-price',
      'product-bundle-builder .bundle-total-price-mobile',
      'product-bundle-builder .total-price',
      'product-bundle-builder .total-compare-price',
      '.product-card-carousel .price-sale',
      '.product-card-carousel .price-compare',
      '.product-card-carousel .price-regular'
    ];

    Array.prototype.forEach.call((root || document).querySelectorAll(selectors.join(',')), patchPriceElement);
  }

  function observePriceElements() {
    if (!isCadCurrency() || !window.MutationObserver || observePriceElements._started) {
      return;
    }

    observePriceElements._started = true;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              patchExistingPriceElements(node);
            }
          });
        } else if (mutation.type === 'characterData' && mutation.target.parentElement) {
          patchPriceElement(mutation.target.parentElement);
        }
      });
    }).observe(document.documentElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  patchCadMoneyFormatters();
  document.addEventListener('DOMContentLoaded', function () {
    patchCadMoneyFormatters();
    patchExistingPriceElements(document);
    observePriceElements();
  });
  window.addEventListener('load', function () {
    patchCadMoneyFormatters();
    patchExistingPriceElements(document);
    observePriceElements();
  });
})();
